import { render, staticRenderFns } from "./ModalCopyPrice.vue?vue&type=template&id=06a330d0&"
import script from "./ModalCopyPrice.vue?vue&type=script&lang=js&"
export * from "./ModalCopyPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports